module.exports = __webpack_public_path__ + "static/media/esncard_3.d3353f64.jpg";